import { useEffect } from 'react';

type Dimensions = {
    pageXOffset: number;
    pageYOffset: number;
};

type Handler = (dimensions: Dimensions) => void;

/** Эффект, срабатывает при скроллинге основной страницы */
export const useWindowScroll = (onScroll: Handler, deps: any[] = []) => {
    const handler = () => {
        const { pageXOffset, pageYOffset } = window;
        onScroll({ pageXOffset, pageYOffset });
    };

    return useEffect(() => {
        window.addEventListener('scroll', handler);
        return () => window.removeEventListener('scroll', handler);
    }, deps);
};
